import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid'
import { IconButton, Tooltip } from '@mui/material'
import React from 'react'
import { DownloadIcon, EyeIcon, FileTextIcon, ImageIcon, ListPlusIcon } from '../icons/icons'

export enum ViewAction {
    View = 'view',
    Download = 'download'
}

const actionButtonSx = {
    color: 'primary.main',
    '&:hover': { bgcolor: 'var(--pb-tint)' }
};

// MUI Tooltip renders in a portal, so the hint is not clipped by the grid rows
export const PbColumns: GridColDef[] = [
    {
        field: 'extension', headerName: 'Tipo', headerAlign: 'center',
        width: 80, editable: false,
        disableColumnMenu: true,
        align: 'center',
        renderCell: (params: GridRenderCellParams<string>) => {
            const extension = (params.value || '').toLowerCase();
            const isPdf = extension === 'pdf';
            const tip = isPdf ? 'Arquivo PDF' : `Imagem${extension ? ` (${extension.toUpperCase()})` : ''}`;

            return <Tooltip title={tip} arrow>
                <span role='img' aria-label={tip} style={{ display: 'inline-flex', color: isPdf ? 'var(--pb-danger)' : 'var(--pb-accent-strong)' }}>
                    {isPdf ? <FileTextIcon size={20} /> : <ImageIcon size={20} />}
                </span>
            </Tooltip>
        }
    },
    { field: 'title', headerName: 'Título', width: 250, editable: false, disableColumnMenu: false, flex: 1 },
    {
        field: 'view', headerName: 'Ação', headerAlign: 'center',
        width: 80, editable: false,
        disableColumnMenu: true, sortable: false,
        align: 'center',
        renderCell: (params: GridRenderCellParams<ViewAction>) => {
            const download = params.value === ViewAction.Download;
            const tip = download ? 'Baixar' : 'Visualizar';

            return <Tooltip title={tip} arrow>
                <IconButton size='small' aria-label={`${tip} ${params.row.title}`} sx={actionButtonSx}>
                    {download ? <DownloadIcon /> : <EyeIcon />}
                </IconButton>
            </Tooltip>
        }
    },
    {
        field: 'repertoire', headerName: 'Repertório',
        width: 120, editable: false,
        disableColumnMenu: true, sortable: false, headerAlign: 'center',
        align: 'center',
        renderCell: (params: GridRenderCellParams<string>) => (
            <Tooltip title='Adicionar ao repertório' arrow>
                <IconButton size='small' aria-label={`Adicionar ${params.row.title} ao repertório`} sx={actionButtonSx}>
                    <ListPlusIcon />
                </IconButton>
            </Tooltip>
        )
    }
]
